export function initGallery() {
    const gallerySection = jQuery('#galerij');
    
    if (!gallerySection.length) {
        return;
    }
    
    // Haal gallery data op
    const galleryData = JSON.parse(jQuery('#gallery-images-data').html() || '[]');
    if (galleryData.length === 0) {
        return;
    }
    
    let currentIndex = 0;
    const lightbox = jQuery('#gallery-lightbox');
    const mainImg = jQuery('#gallery-main-img');
    const lightboxImg = jQuery('#gallery-lightbox-img');
    const currentCounter = jQuery('#gallery-current');
    const totalCounter = jQuery('#gallery-total');
    const thumbnails = jQuery('.gallery-thumbnail');
    const mainImageWrapper = jQuery('.gallery-main-image');
    
    // Update total counter
    totalCounter.text(galleryData.length);
    
    // Update main image
    function updateMainImage(index) {
        currentIndex = index;
        const imageData = galleryData[index];
        if (imageData) {
            mainImg.attr('src', imageData.large);
            
            // Update active thumbnail (alleen als deze bestaat)
            thumbnails.removeClass('active');
            if (thumbnails.length > index) {
                thumbnails.eq(index).addClass('active');
            }
            
            // Update counter
            currentCounter.text(index + 1);
        }
    }
    
    // Open lightbox
    function openLightbox(index) {
        currentIndex = index;
        const imageData = galleryData[index];
        if (imageData) {
            lightboxImg.attr('src', imageData.full);
            lightbox.addClass('active');
            jQuery('body').css('overflow', 'hidden');
            currentCounter.text(index + 1);
        }
    }
    
    // Close lightbox
    function closeLightbox() {
        lightbox.removeClass('active');
        jQuery('body').css('overflow', '');
    }
    
    // Navigate in lightbox
    function navigateLightbox(direction) {
        if (direction === 'next') {
            currentIndex = (currentIndex + 1) % galleryData.length;
        } else {
            currentIndex = (currentIndex - 1 + galleryData.length) % galleryData.length;
        }
        const imageData = galleryData[currentIndex];
        if (imageData) {
            lightboxImg.attr('src', imageData.full);
            currentCounter.text(currentIndex + 1);
            // Update main image to match lightbox
            updateMainImage(currentIndex);
        }
    }
    
    // Thumbnail click - update main image and open lightbox
    thumbnails.on('click', function() {
        const index = parseInt(jQuery(this).data('image-index'));
        if (!isNaN(index) && index < galleryData.length) {
            updateMainImage(index);
            openLightbox(index);
        }
    });
    
    // Main image click - open lightbox
    mainImageWrapper.on('click', function() {
        openLightbox(currentIndex);
    });
    
    // Lightbox controls
    jQuery('.gallery-lightbox-close').on('click', function(e) {
        e.stopPropagation();
        closeLightbox();
    });
    
    jQuery('.gallery-lightbox-prev').on('click', function(e) {
        e.stopPropagation();
        navigateLightbox('prev');
    });
    
    jQuery('.gallery-lightbox-next').on('click', function(e) {
        e.stopPropagation();
        navigateLightbox('next');
    });
    
    // Close on overlay click
    lightbox.on('click', function(e) {
        if (e.target === this) {
            closeLightbox();
        }
    });
    
    // Keyboard navigation
    jQuery(document).on('keydown', function(e) {
        if (!lightbox.hasClass('active')) {
            return;
        }
        
        if (e.key === 'Escape') {
            closeLightbox();
        } else if (e.key === 'ArrowLeft') {
            navigateLightbox('prev');
        } else if (e.key === 'ArrowRight') {
            navigateLightbox('next');
        }
    });
}
